import type { SupportTicketId } from "@redotech/effect-api-shared/ids/definitions";
import type { Message } from "@redotech/effect-api-shared/models/shopper-ai/conversation/message";
import type { ChannelThread } from "@redotech/effect-api-shared/models/shopper-ai/conversation/thread";
import { memo } from "react";
import { ChatThreadView } from "./chat-thread-view";

interface SmsThreadViewProps {
  messages: Message[];
  supportTicketId: SupportTicketId;
  thread: ChannelThread;
}

export const SmsThreadView = memo(function SmsThreadView({
  messages,
  supportTicketId,
  thread,
}: SmsThreadViewProps) {
  return (
    <ChatThreadView
      channel="sms"
      messages={messages}
      supportTicketId={supportTicketId}
      thread={thread}
    />
  );
});
